import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../apiConfig";

const DEFAULTS = {
  instagram: "https://www.instagram.com/artbyarawol",
  facebook: "https://www.facebook.com/arawol/",
  linkedin: "",
  youtube: "",
  tiktok: "",
};

let cache = null;

export const useSocialLinks = () => {
  const [links, setLinks] = useState(cache || DEFAULTS);

  useEffect(() => {
    if (cache) return;
    axios
      .get(`${API}/admin/site-settings/social`)
      .then((res) => {
        cache = { ...DEFAULTS, ...res.data };
        setLinks(cache);
      })
      .catch(() => {});
  }, []);

  return links;
};

export default useSocialLinks;
